"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TIMEFRAME = void 0;

var _keyMirror = _interopRequireDefault(require("react-utils/keyMirror"));

var TIMEFRAME = (0, _keyMirror.default)({
  DAILY: null,
  WEEKLY: null,
  BIWEEKLY: null,
  MONTHLY: null
});
exports.TIMEFRAME = TIMEFRAME;